import Config from '@/config'
import { resolveMarketplaceBase } from '@/utils/resolveMarketplaceBase'

const FETCH_TIMEOUT_MS = 8000

const isValidOption = (option) => Boolean(option) && option.id != null && typeof option.label === 'string'

const normaliseField = (field) => ({
  field: field.field,
  label: typeof field.label === 'string' ? field.label : field.field,
  options: (Array.isArray(field.options) ? field.options : []).filter(isValidOption),
})

/**
 * The slide-type categorisation schema served next to the /api/slide-types
 * catalogue: which catalogue field is the primary browsing dimension, and every
 * field's selectable options. Resolves to `{ primaryField, fields }`, or `null`
 * when the endpoint is unavailable or returns an unusable shape, so callers can
 * fall back to their built-in filters. Never rejects.
 */
export const fetchSlideTypeFields = async () => {
  const base = resolveMarketplaceBase(Config.ahaslideMarketplaceUrl, Config.presenterDomain)
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = controller ? setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS) : null
  try {
    const response = await fetch(
      `${String(base).replace(/\/+$/, '')}/api/slide-type-fields`,
      controller ? { signal: controller.signal } : undefined,
    )
    if (!response.ok) return null
    const data = await response.json()
    if (!data || typeof data.primaryField !== 'string' || !Array.isArray(data.fields)) return null
    return {
      primaryField: data.primaryField,
      fields: data.fields.filter((field) => field && typeof field.field === 'string').map(normaliseField),
    }
  } catch (e) {
    return null
  } finally {
    if (timer) clearTimeout(timer)
  }
}

export default fetchSlideTypeFields
